export default __webpack_public_path__ + "5d5ddfcc34e08b3682d8470a4dcee066.png";